import axiosInstance from '@/services/api';
import logger from '@/utils/logger';

const setup = (store) => {
    axiosInstance.interceptors.request.use(
        async (config) => {
            try {
                if (store.authenticated) {
                    config.headers.Authorization = `Bearer ${store.token}`;
                } else {
                    window.location.href = '/SignInRegister';
                }
            } catch (error) {
                return Promise.reject(error);
            }

            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    axiosInstance.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            // while (store.loadingProfile) { 
            //     await new Promise(resolve => setTimeout(resolve, 100)); // Wait for 100ms
            // }
            
            const originalRequest = error.config;
            if (error.response?.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    await store.refreshUserToken();
                    originalRequest.headers.Authorization = `Bearer ${store.token}`;
                    return axiosInstance(originalRequest);
                } catch (refreshError) {
                    logger.error('Error refreshing token', refreshError);
                }
            } else if (error.response?.status === 401) {
                window.location.href = '/unauthorized';
            }

            return Promise.reject(error);
        }
    );
};

export default setup;